import React from 'react';
import { HeartHandshakeIcon } from 'lucide-react';
const links = [{
  label: 'Términos de Servicio',
  href: '#terminos'
}, {
  label: 'Política de Privacidad',
  href: '#privacidad'
}, {
  label: 'Contacto',
  href: '#contacto'
}];
export function Footer() {
  return <footer className="w-full bg-plum-900 py-14 text-white md:py-16" data-id="element-72" data-mp="32m1et8sa9itd">
      <div className="mx-auto w-full max-w-narrow px-5 text-center md:px-8" data-id="element-73" data-mp="36ppk1ktg02bg">
        <p className="inline-flex items-center gap-2.5 font-display text-sm font-extrabold uppercase tracking-[0.14em] text-gold-300 md:text-base" data-id="element-74" data-mp="3ug3c3bc12161">
          <span className="h-3 w-3 rounded-full bg-rose-400 ring-4 ring-rose-400/20" aria-hidden="true" data-id="element-75" data-mp="36d08okdmdj3" />
          Protocolo Octubre Rosa™
        </p>

        <p className="mt-6 text-sm text-rose-200" data-id="element-76" data-mp="3qfjhofiu9bnl">
          © 2026 Protocolo Octubre Rosa™ | Todos los derechos reservados
        </p>

        <p className="mt-6 inline-flex items-center gap-2 rounded-xl bg-plum-800 px-4 py-2.5 text-sm font-semibold text-rose-100 ring-1 ring-plum-700" data-id="element-77" data-mp="2eyt8cnj4c3pr">
          <HeartHandshakeIcon className="h-4 w-4 shrink-0 text-gold-300" aria-hidden="true" data-id="element-78" data-mp="3l9sfwwylmeks" />
          Si necesitas apoyo emocional, contacta a un profesional de la salud mental
        </p>

        <ul className="mt-6 flex flex-wrap items-center justify-center gap-x-7 gap-y-3 text-sm text-rose-100" data-id="element-79" data-mp="3v919hopjxr6m">
          {links.map(link => <li key={link.label} data-id="element-80" data-mp="82qp7jv45dpi">
              <a href={link.href} className="transition-colors duration-150 ease-calm hover:text-gold-300" data-id="element-81" data-mp="81pexhlx8v8u">
                {link.label}
              </a>
            </li>)}
        </ul>

        <p className="mt-10 border-t border-plum-700 pt-6 text-xs leading-relaxed text-rose-200" data-id="element-82" data-mp="huo87csd59ys">
          Este producto tiene fines exclusivamente educativos y de concientización. Sus recursos no
          sustituyen la consulta médica, psicológica ni la intervención de un profesional de la
          salud.
        </p>
      </div>
    </footer>;
}